import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  wrapper: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      width: '100%',
    },
    width: '65%',
    minWidth: '100%',
  },

  addressAndServiceForm: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
    },
    width: '100%',
  },
  inputOutline: {
    border: '1px solid',
    borderColor: '#e2e2e2',
  },
  inputOutlineError: {
    borderColor: theme.palette.primary.main,
  },
  inputContainer: {
    [theme.breakpoints.down('md')]: {
      width: '70%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '55%',
      marginRight: 16,
    },
    [theme.breakpoints.down('xs')]: {
      width: '95%',
      marginRight: 0,
    },
    width: '65%',
    marginRight: 16,
    height: 56,
    display: 'flex',
  },
  inputClass: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9em',
    },
    fontSize: '1em',
  },
  buttonContainer: {
    [theme.breakpoints.down('xs')]: {
      marginTop: 15,
    },
    textAlign: 'center',
  },
  servicePickerContainer: {
    width: '100%',
    height: 50,
    margin: 'auto',
    display: 'flex',
    backgroundColor: 'white',
  },
  servicePicker: {
    [theme.breakpoints.down('sm')]: {},
    flexGrow: 1,
    height: '100%',
    backgroundColor: 'white',
  },
  serviceSelect: {
    height: '100%',
    padding: 0,
  },
  serviceSelectIcon: {
    right: 15,
  },
  serviceSelectContent: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
      marginLeft: 30,
      fontSize: '0.9em',
      paddingLeft: 0,
    },
    textAlign: 'center',
    color: '#4A4A4A',
    fontWeight: 300,
    lineHeight: '50px',
    paddingRight: 32,
  },
  selectMenu: {
    lineHeight: 50,
  },
  textButton: {
    height: 56,
    fontWeight: 600,
    padding: '0 25px',
    backgroundColor: '#fff',
    borderRadius: 28,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
    },
    fontSize: '1.2rem',
  },
  iconButton: {
    width: 50,
    height: 50,
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
    },
  },
});

export default makeStyles(styles);
